import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ee409fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-training-view" }
const _hoisted_2 = { class: "progress" }
const _hoisted_3 = ["innerHTML"]

import {computed, ref, reactive, onMounted, onUnmounted, watch, inject} from 'vue'
  import {useStore} from 'vuex'
  import {useRoute, useRouter} from 'vue-router'

  import {usePreloader} from '@/lib/preloader.js'

  import {t} from '@/lib/i18n.js'

  import ContentSection from '@/components/ContentSection.vue'
  import AnswerForm from '@/components/forms/AnswerForm.vue'
  import LocalLoader from '@/components/LocalLoader.vue'
  import BufferingNotification from '@/components/BufferingNotification.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingView',
  props: {
    locationId: null,
    step: null
  },
  setup(__props: any) {

const props = __props as {
    locationId: string
    step: string
  };

  const bus = inject('bus')

  const {getAsset} = usePreloader()
  const route = useRoute()
  const router = useRouter()
  const store = useStore()

  const waiting = ref(true)
  const loading = ref(true)

  const MAX_STEPS = 6

  

  const step = computed(() => {
    return route.params.step
  })

  const errors = ref({})

  const locations = store.state.locations

  const locationId = ref(parseInt(props.locationId))
  // const step = ref(parseInt(props.step))

  const currentLocation = locations[locationId.value]
  const steps = currentLocation.steps

  const currentStep = computed(() => {
    return steps[step.value]
  })

  const options = currentStep.value.options
  const rightAnswer = currentStep.value.answer

  const answer = reactive({answer: {}})

  // const titleText = computed(() => t(store, 'training.title'))
  const contentText = computed(() => t(store, 'training.content'))
  const progressText = computed(() =>
    t(store, 'training.progress', [step.value, MAX_STEPS])
  )

  const progress = computed(() => (parseInt(step.value) / MAX_STEPS) * 100)

  const audioPath = require(`@/assets/audio/locations/${locationId.value}/${step.value}-optimized.mp3`)

  const onSubmit = () => {
    if (parseInt(step.value) < MAX_STEPS) {
      router.push({
        name: 'active.training',
        params: {locationId: 1, step: parseInt(step.value) + 1}
      })
    } else {
      router.push({name: 'active.science-intro-intro'})
    }

    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - select correct quiz answer',
        label: step.value
      }
    })
  }

  let wanted = true
  let a

  const muted = computed(() => store.state.muted)

  onMounted(() => {
    getAsset({type: 'AUDIO', path: audioPath}).then((audio) => {
      if (wanted) {
        loading.value = false

        audio.muted = muted.value
        audio.loop = true
        audio.play()

        a = audio

        audio.addEventListener('waiting', () => {
          waiting.value = true
        })

        audio.addEventListener('playing', () => {
          waiting.value = false
        })
      }
    })
  })

  watch(muted, (value) => (a.muted = value))

  onUnmounted(() => {
    if (a) {
      a.pause()
      a.currentTime = 0
    }
  })

  const globalPaused = computed(() => store.state.paused)

  watch(globalPaused, (value) => {
    if (value) {
      a.pause()
    } else {
      a.play()
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "words",
        innerHTML: _unref(progressText)
      }, null, 8, _hoisted_3),
      _createVNode(LocalLoader, { "percent-loaded": _unref(progress) }, null, 8, ["percent-loaded"])
    ]),
    _createVNode(ContentSection, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(contentText)), 1)
      ]),
      _: 1
    }),
    _createVNode(AnswerForm, {
      modelValue: answer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((answer) = $event)),
      options: _unref(options),
      errors: errors.value,
      "right-answer": _unref(rightAnswer),
      progress: _unref(progress),
      onSubmit: onSubmit
    }, null, 8, ["modelValue", "options", "errors", "right-answer", "progress"]),
    _createVNode(BufferingNotification, {
      active: waiting.value || loading.value,
      class: "loading"
    }, null, 8, ["active"])
  ]))
}
}

})